app.component("taskLabelsSetting", {
	templateUrl: "app/src/views/templates/tasks-labels.tmpl.html",
	controller: "taskLabelsController",
	bindings: { practiceId: "<" },
});

app.controller('taskLabelsController',['$scope', '$mdDialog', 'TasksAPI', "Session","$modal","$q",
function($scope, $mdDialog, TasksAPI,Session,$modal,$q){
   $scope.myColor = '#FF0000';
   $scope.API = TasksAPI;
   $scope.task_labels = [];
   $scope.$mdDialog = $mdDialog;
   $scope.newType = {colour: 'FFFFFF', name: ''};
   $scope.Session = Session;
   $scope.saveStatus = '';

   // options - if a list is given then choose one of the items. The first item in the list will be the default
$scope.options = {
	hue: true,
	saturation: false,
	lightness: false,
	alpha: false,
	inline: true,
	format: "hex",
	round: false,
	inline: false,
	inputClass: "form-control",
	dynamicHue: false,
	dynamicLightness: false,
	dynamicSaturation: false,
	dynamicAlpha: false,
};

// Name + colour of each label as last persisted, so save() only sends what changed.
let saved = {};

function rememberSaved() {
    saved = {};
    $scope.task_labels.forEach(t => saved[t.task_label_id] = { name: t.name, colour: t.colour });
}

function hasChanged(label) {
    const before = saved[label.task_label_id];
    return !before || before.colour !== label.colour || before.name !== label.name;
}

this.$onInit = function () {
    $scope.practiceId = this.practiceId || (Session.practice && Session.practice.id);
    const practice = (Session.practiceOptions || []).find(p => p.id === $scope.practiceId) || Session.practice || {};
    $scope.practiceName = practice.name || "";
    querySetting();
};

function querySetting() {
    $scope.API.queryTaskLabels($scope.practiceId)
    .then(
        function (resp) {
            $scope.task_labels = resp.data.filter(t=>t.practice_id === $scope.practiceId);
            rememberSaved();
        },
        function (error) {
            console.error("Unable to load task labels", error && error.status);
        }
    );
}
$scope.errors = [];

$scope.renderErrorMessage = function (name='', task_label_id) {
    const val = name && $scope.task_labels.find(t=>t.name === name.trim() && t.task_label_id !== task_label_id);
    if(val && !$scope.errors.some(t=> t === task_label_id)){
        $scope.errors.push(task_label_id);
    }else if(!val){
        $scope.errors = $scope.errors.filter(t=> t !== task_label_id);
    }
    return {
        duplicate: val
    };
}

$scope.hasUnsavedChanges = function () {
    return $scope.task_labels.some(hasChanged);
}

// Drop a stale "saved" tick as soon as the user edits another colour.
$scope.$watch($scope.hasUnsavedChanges, function (dirty) {
    if (dirty) {
        $scope.saveStatus = '';
    }
});

// Colours used to save the moment the picker lost focus, which made this the only
// settings page without a Save button. Each label is its own PUT, so send the
// changed ones together.
$scope.save = function () {
    const changed = $scope.task_labels.filter(hasChanged);
    if (!changed.length) {
        $scope.saveStatus = 'No changes to save';
        return;
    }

    $scope.API.isProcessing = true;
    $scope.saveStatus = 'Saving...';

    $q.all(changed.map(t => $scope.API.updateTaskLabel(t.task_label_id, t, $scope.practiceId)))
    .then(
        function () {
            rememberSaved();
            $scope.saveStatus = 'Task labels saved';
        },
        function (error) {
            console.error("Unable to save task labels", error && error.status);
            $scope.saveStatus = 'Error saving task labels';
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }
    )
    .finally(() => ($scope.API.isProcessing = false));
}

$scope.addSetting = function(){
    $scope.API.isProcessing = true;
    $scope.saveStatus = 'Saving...';

    // Adding reloads the list from the server, so flush any pending colour edits first
    // rather than throwing them away.
    const changed = $scope.task_labels.filter(hasChanged);

    $q.all(changed.map(t => $scope.API.updateTaskLabel(t.task_label_id, t, $scope.practiceId)))
    .then(() => $scope.API.addTaskLabel($scope.newType, $scope.practiceId))
    .then(
        function (resp) {
            $scope.newType = {colour: 'FFFFFF', name: ''};
            $scope.saveStatus = changed.length ? 'Label added and changes saved' : 'Label added';
            querySetting();
        },
        function (error) {
            console.error("Unable to add task label", error && error.status);
            $scope.saveStatus = 'Error adding label';
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }
    )
    .finally(() => ($scope.API.isProcessing = false));
}


}]);